import {Organization} from "../../../types/Organization";

type SortOrganizationsProps = {
  organizations: Organization[];
  sortColumn: string;
  sortOrder: "asc" | "desc";
};

export const sortOrganizations = ({
  organizations,
  sortColumn,
  sortOrder,
}: SortOrganizationsProps) => {
  return organizations.sort((a, b) => {
    if (!sortColumn) return 0;
    const valueA = a[sortColumn];
    const valueB = b[sortColumn];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }
    return 0;
  });
};
